<template>
  <div :class="['cbaas-detail-table']">
    <detail-section
      :title="title"
      :show-border="showBorder"
      :show-inner-actions="showInnerActions"
      :show-title="true"
    >
      <template #actions>
        <slot name="actions"></slot>
      </template>
      <template #inner-actions>
        <slot name="inner-actions"></slot>
      </template>
      <div class="content-frame">
        <el-row>
          <el-col
            v-for="(item, index) in tableCol"
            :key="item + index"
            :span="item.span || span"
            :offset="item.offset"
            :pull="item.pull"
            :push="item.push"
            :class="item.className"
          >
            <div class="detail-item">
              <div class="icon">
                <img :src="item.icon" alt="" />
              </div>
              <div class="right">
                <div class="label">{{ item.label }}</div>
                <div class="content">
                  <template v-if="item.slotName">
                    <slot :name="item.slotName" :param="list[item.value]"></slot>
                  </template>
                  <template v-else>
                    <span v-if="item.formatter" class="text">{{
                      item.formatter(list, item.value)
                    }}</span>
                    <span v-else>{{ list[item.value] || $constants.EMPTY }}</span>
                  </template>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </detail-section>
  </div>
</template>

<script>
import detailSection from './detailSection'
export default {
  name: 'DetailTable',
  components: {
    detailSection
  },
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    tableCol: {
      type: Array,
      default: () => {
        return []
      }
    },
    list: {
      type: Object,
      default: () => {
        return {}
      }
    },
    span: {
      type: Number,
      default: () => {
        return 12
      }
    },
    showBorder: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    showInnerActions: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'cbaas-detail-table',
  (
    --cbaas-detail-table-item-color: #fff,
    --cbaas-detail-table-item-label-color: #a5b3b9
  ),
  (
    --cbaas-detail-table-item-color: #192227,
    --cbaas-detail-table-item-label-color: #5a6973
  )
);
.cbaas-detail-table {
  @include adaptation(
    (
      --cbaas-detail-table-content-frame-padding: 12px 16px,
      --cbaas-detail-table-el-row-margin: 0 -64px,
      --cbaas-detail-table-el-col-padding: 0 64px,
      --cbaas-detail-table-item-font-size: 12px,
      --cbaas-detail-table-item-padding: 12px 16px,
      --cbaas-detail-table-item-min-height: 70px,
      --cbaas-detail-table-item-icon-wrap-height: 46px,
      --cbaas-detail-table-item-icon-margin-right: 16px,
      --cbaas-detail-table-item-icon-size: 28px,
      --cbaas-detail-table-item-label-margin-bottom: 8px
    )
  );
  overflow: hidden;

  .content-frame {
    padding: var(--cbaas-detail-table-content-frame-padding);

    .el-row {
      margin: var(--cbaas-detail-table-el-row-margin);

      .el-col {
        padding: var(--cbaas-detail-table-el-col-padding);

        .detail-item {
          display: flex;
          min-height: var(--cbaas-detail-table-item-min-height);
          padding: var(--cbaas-detail-table-item-padding);
          color: var(--cbaas-detail-table-item-color);
          font-size: var(--cbaas-detail-table-item-font-size);

          .icon {
            margin-right: var(--cbaas-detail-table-item-icon-margin-right);
            display: flex;
            align-items: center;
            height: var(--cbaas-detail-table-item-icon-wrap-height);

            img {
              width: var(--cbaas-detail-table-item-icon-size);
              height: var(--cbaas-detail-table-item-icon-size);
            }
          }

          .right {
            width: 100%;

            .label {
              color: var(--cbaas-detail-table-item-label-color);
              margin-bottom: var(--cbaas-detail-table-item-label-margin-bottom);
            }

            .content {
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
</style>
